export const APP_ROUTES = {
  LANDING: '/',
  SEARCH: '/search',
  LOGIN: '/login',
  LOGIN_SUCCESS: '/login-success',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot',
  RESET_PASSWORD: '/reset',
  MAIL: '/mail',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  DASHBOARD: '/dashboard',
  DASHBOARD_FIELD: '/dashboard/field',
  DASHBOARD_FIELD_MEMBERS: '/dashboard/field/members',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_FIELDS: '/admin/fields',
  ADMIN_USERS: '/admin/users',
  ADMIN_METRICS: '/admin/metrics',
  ADMIN_BILLING: '/admin/billing',
  FAVORITES: '/favorites',
  NOTIFICATIONS: '/notifications',
  PROFILE: '/profile',
  UNAUTHORIZED: '/unauthorized',
} as const;
